import { supabase } from './supabaseClient';

export interface ActiveLens {
  id: string;
  archetypeId: string;
  label: string;
  insightText: string;
}

export interface LensSelection {
  id: string;
  userId: string;
  songId: string;
  archetypeId: string;
  createdAt: string;
  updatedAt: string;
}

export async function getActiveLensForSong(userId: string, songId: string): Promise<ActiveLens | null> {
  const { data, error } = await supabase
    .from('explorer_lens_selections')
    .select(`
      id,
      archetype_id,
      insight_archetypes (
        id,
        category,
        insight_text
      )
    `)
    .eq('user_id', userId)
    .eq('song_id', songId)
    .maybeSingle();

  if (error) {
    console.error('[explorerLensService] Error fetching active lens:', error);
    return null;
  }

  if (!data || !data.insight_archetypes) {
    return null;
  }

  const archetype = data.insight_archetypes as any;

  return {
    id: data.id,
    archetypeId: data.archetype_id,
    label: archetype.category.toUpperCase(),
    insightText: archetype.insight_text,
  };
}

export async function setActiveLens(
  userId: string,
  songId: string,
  archetypeId: string
): Promise<{ success: boolean; error?: string }> {
  const { error } = await supabase
    .from('explorer_lens_selections')
    .upsert(
      {
        user_id: userId,
        song_id: songId,
        archetype_id: archetypeId,
        updated_at: new Date().toISOString(),
      },
      {
        onConflict: 'user_id,song_id',
      }
    );

  if (error) {
    console.error('[explorerLensService] Error setting active lens:', error);
    return { success: false, error: error.message };
  }

  return { success: true };
}

export async function clearActiveLens(
  userId: string,
  songId: string
): Promise<{ success: boolean; error?: string }> {
  const { error } = await supabase
    .from('explorer_lens_selections')
    .delete()
    .eq('user_id', userId)
    .eq('song_id', songId);

  if (error) {
    console.error('[explorerLensService] Error clearing active lens:', error);
    return { success: false, error: error.message };
  }

  return { success: true };
}
